import { useEffect, useState } from "react"

import type { OnboardingLockTarget } from "./map-quiz-to-target"
import {
  formatOnboardingLockLabel,
  remainingOnboardingLockMs,
  useOnboardingLockStore,
} from "./onboarding-lock-store"

/**
 * Live remaining time for the onboarding lock.
 * `isLocked(target)` is true only while this specific target is gated.
 */
export function useOnboardingLock() {
  const startedAt = useOnboardingLockStore((s) => s.startedAt)
  const target = useOnboardingLockStore((s) => s.target)
  const skipped = useOnboardingLockStore((s) => s.skipped)
  const [now, setNow] = useState(() => Date.now())

  const remainingMs = remainingOnboardingLockMs(startedAt, skipped, now)
  const active = remainingMs > 0 && target !== null

  useEffect(() => {
    if (!active) return
    const id = window.setInterval(() => setNow(Date.now()), 1000)
    return () => window.clearInterval(id)
  }, [active])

  const isLocked = (t: OnboardingLockTarget) => active && target === t

  return {
    target,
    active,
    remainingMs,
    remainingLabel: active ? formatOnboardingLockLabel(remainingMs) : null,
    isLocked,
  }
}
